<template>
  <a-drawer
:maskClosable="false"
width="35%"
:label-col="4"
:wrapper-col="14"
:visible="open"
@close="onClose"
:destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="编号" prop="code">
        <a-input v-model="form.code" placeholder="请输入" :disabled="form.id ? true : false" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="类型" prop="type">
        <a-radio-group v-model="form.type" button-style="solid">
          <a-radio-button :value="0"> 平台 </a-radio-button>
          <a-radio-button :value="1"> 企业 </a-radio-button>
          <!-- <a-radio-button :value="2"> 跳外部地址</a-radio-button> -->
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="尺寸宽" prop="size1">
        <a-input v-model="form.size1" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>

      <a-form-model-item label="尺寸高" prop="size2">
        <a-input v-model="form.size2" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getObj, addObj, putObj } from '@/api/pressure/advertisement'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      submitLoading: false,
      data: [],
      formTitle: '',
      inputValue: '',
      inputValues: '',
      // 表单参数
      form: {
        id: undefined,
        code: undefined,
        name: undefined,
        remark: undefined,
        type: 0,
        sort: 99,
      },
      isShow: false,
      tags: [],
      tagslist: [],
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      inputVisible: false,
      inputVisibles: false,
      showLoading: false,
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入编号', trigger: 'blur' }],
        size1: [{ required: true, message: '请输入宽', trigger: 'blur' }],
        size2: [{ required: true, message: '请输入高', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入备注', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {},
  watch: {},
  methods: {
    onClose() {
       const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() {},
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        code: undefined,
        remark: undefined,
        name: undefined,
        type: 0,
        sort: 99,
      }
      this.tags = []
      this.tagslist = []
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加广告'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        if (response.data.size) {
          const sizes = response.data.size.split('*')
          console.log(sizes, 'sizessizes')
          response.data.size1 = sizes[0]
          response.data.size2 = sizes[1]
        }
        this.form = response.data
        this.open = true
        this.formTitle = '修改广告'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.form.size = this.form.size1 + '*' + this.form.size2
          this.submitLoading = true
           this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          if (this.form.id !== undefined) {
            this.form.fileUrl = '1'
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          }
        } else {
            const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.model_t {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  input {
    width: 30%;
    margin-right: 10px;
  }
}
</style>
